<template>
<div>
    <v-row>
        <v-checkbox
            v-model="is_enabled"
            label="Использовать функцию повтора IVR"
            @change="cahngeIvrRepeat()"
        ></v-checkbox>
    </v-row>
    <v-row v-if="is_enabled">
        <v-col>
            <v-text-field
                outlined
                v-model="repeat_count"
                label="Количество повторений (1-10)"
                @change="cahngeIvrRepeat()"
            ></v-text-field>
        </v-col>
        <v-col>
            <audioSelector :element="element" type="repeatRecord"/>
        </v-col>
    </v-row>
</div>    
</template>

<script>
import audioSelector from "./audioSelector";
export default {
    name: "ivrRepeat",
    components: {
        audioSelector,
    },
    props: ["element"],
    data() {
        return {
            is_enabled: false,
            repeat_count: 1,
        }        
    },
    created() {
        if (this.element.hasOwnProperty("repeatCount")) {
            this.is_enabled = true;
            this.repeat_count = this.element["repeatCount"];
        }
    },
    methods: {
        cahngeIvrRepeat() {
            if (this.is_enabled) {
                this.element["repeatCount"] = this.repeat_count;
            } else {
                if (this.element.hasOwnProperty("repeatRecord")) {
                    delete this.element["repeatRecord"]
                }
                if (this.element.hasOwnProperty("repeatCount")) {
                    delete this.element["repeatCount"]
                }
            }
            this.element.ivrs.push();
        }
    }
}
</script>

<style>

</style>